

import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import Img from "react-cool-img";

// import Linkify from 'react-linkify';
import { useTranslation } from 'react-i18next/hooks';

import FilesUploadAction from '../../../../FileUploadAction/FilesUploadAction';
import GroupTalkTextModal from '../../GroupTalkTextModal';
import GroupTalkTextReplyAction from './GroupTalkTextReplyAction';
import GroupTextItemReplys from './GroupTextItemReplys';
import Loader from '../../../../Loader/Loader';
import SmallModal from '../../../../Modal/SmallModal';
import TransBackdrop from '../../../../Backdrop/TransBackdrop';

import { useStore } from '../../../../../hook-store/store';
import { 
  getKuraBucketFileSignedUrl,
} from '../../../../../util/group/kura-bucket-file';

import { SOCKET_GROUP_URL } from '../../../../../App';
import { marks } from '../../../../../images/marks';
import classes from '../GroupTalkTextItem.module.css';



import GroupTalkTextFileKura from '../../GroupTalkTextFile/GroupTalkTextFileKura';


const GroupTalkTextItemSettings = (props) => {
  // console.log('GroupTalkTextItem-props', props);

  const { 
    inputData, 
    userId, 
    // userColorList, 
    // groupAllMemberList,
    groupTextDeleteHandler,
    groupTextPostHandler,
    isTextPosting,
    lsNameDataList,
    // replyTexts,
    showTextSettings, 
    setShowTextSettings,
    kuraFileIconRef,
    isLoading,
   } = props;

  //  console.log('inputData', inputData);
  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    selectedKuraFileData,
    isGroupMember,
   } = store.groupStore;
  const {
    isAuth,
  } = store.uiStore;

  // console.log('store in GroupTalkTextItem', store);

  // const [showTextSettings, setShowTextSettings] = useState(false);
  const [showDeleteTextModal, setShowDeleteTextModal] = useState(false);
  const [showFileUploadModal, setShowFileUploadModal] = useState(false);
  const [showReplyModal, setShowReplyModal] = useState(false);
  const [isDownLoading, setIsDownLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [isTextCopied, setIsTextCopied] = useState(false);

  useEffect(() => {
    if (!showTextSettings) {
      setErrorMessage('');
    }
  },[showTextSettings]);

  const showTextSettingHandler = () => {
    setShowTextSettings(!showTextSettings);
  }

  const showDeleteTextModalHandler = () => {
    setShowDeleteTextModal(!showDeleteTextModal);
    setShowTextSettings(false);
  }

  const showFileUploadModalHandler = () => {
    if (inputData.filePaths?.length > 0 || inputData.kuraFileInfo?.key) {
      setShowFileUploadModal(!showFileUploadModal);
      setShowTextSettings(false);
    }
  };

  const showKuraFileCopyModalHandler = () => {
    if (kuraFileIconRef.current) {
      kuraFileIconRef.current.click();
      setShowTextSettings(false);
    }
  }

  const showReplyModalHandler = (value) => {
    setShowReplyModal(value);
    setShowTextSettings(false);
  };

  const getKuraFileSignedUrlHandler = async (
    kuraFileInfo,
    groupRoomId,
  ) => {
    try {
      if (!isGroupMember) {
        throw new Error('group-member-error')
      }
      
      //// reuse selectedKuraFileData signedUrl for download
      if (selectedKuraFileData && selectedKuraFileData.signedUrl &&
        selectedKuraFileData.bucket === kuraFileInfo.bucket &&
        selectedKuraFileData.key === kuraFileInfo.key
      ) {
        window.open(selectedKuraFileData.signedUrl, '_blank', 'noopener','noreferrer');
        return;
      }

      setIsDownLoading(true);
      setErrorMessage('');

      const resData = await getKuraBucketFileSignedUrl(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
        kuraFileInfo.bucket,
        kuraFileInfo.key,
        kuraFileInfo.initialKey,
        groupRoomId,
      );

      if (resData?.data.url) {
       const url = resData.data.url; 
       window.open(url, '_blank', 'noopener','noreferrer');
      //  .focus(); 
      }

      setIsDownLoading(false);

    } catch(err) {
      console.log(err);
      setIsDownLoading(false);
      setErrorMessage('Get file failed.');

      if (err.message === 'bucket-object-not-found') {
        setErrorMessage('Get file failed. File not found. File might be deleted.');
      }
      throw err;
    }
  };

  const copyTextContentHandler = (text) => {
    navigator.clipboard.writeText(text);

    setIsTextCopied(true);

    setTimeout(() => {
      setIsTextCopied(false);
    }, 1000*3)
  };

  let storeFileStyle = null;

  if (!inputData.kuraFileInfo?.key && inputData.filePaths.length === 0) {
    storeFileStyle = { color: "gray" };
  }

  let textSettingsBody;

  if (isGroupMember) {
    textSettingsBody = (
      <div>
        <div className={classes.groupTalkTextItemSettingButtonContainer}>
          <span className={classes.groupTalkTextItemSettingButton}
            onClick={() => { setShowTextSettings(!showTextSettings); }}
          >
            &#8942;
          </span>
        </div>
      </div>
    );
  }
  
  if (isGroupMember && showTextSettings) {
    textSettingsBody= (
      <div>
        <TransBackdrop onClick={showTextSettingHandler} />
          <SmallModal style={classes.groupTalkTextItemConfirmModal}>
            <div className={classes.groupTalkTextItemSettingButtonContainer}>
              <span className={classes.groupTalkTextItemSettingButton}
                onClick={() => { setShowTextSettings(!showTextSettings); }}
              >
                {/* &#8942; */}
                X
              </span>
            </div>

            <div className={classes.groupTalkTextItemTextDeleteButton}
              onClick={() => { 
                copyTextContentHandler(inputData.text);
              }}
            >
              {marks.copyMark} {t('groupTalk.text101', 'Copy text')}
              {isTextCopied && (
                <span>{' '}({t('groupTalk.text102', 'copied')})</span>
              )}
            </div>

            <div className={classes.groupTalkTextItemTextDeleteButton}
              // style={storeFileStyle}
              onClick={() => { 
                showReplyModalHandler(true);
              }}
            >
              {marks.replyMark} {marks.pencilSquareOMark}
              {' '}
              {t('groupTalk.text103', 'Write reply message')}
            </div>

            <div className={classes.groupTalkTextItemTextDeleteButton}
              style={storeFileStyle}
              onClick={() => { 
                // showFileUploadModalHandler();
                showKuraFileCopyModalHandler();
              }}
            >
              {marks.uploadMark} {t('groupTalk.text61', 'Store file')} 
            </div>
            
            {inputData.kuraFileInfo?.key && !isDownLoading && (
              <div className={classes.groupTalkTextItemTextDeleteButton}
                onClick={(() => {
                  getKuraFileSignedUrlHandler(
                    inputData.kuraFileInfo,
                    inputData.groupRoomId,
                  );
                })}
              >
                <span>
                  {marks.downloadMark} {t('groupTalk.text104', 'Download File')}
                </span>
              </div>
            )}
            {errorMessage && (
              <div>{errorMessage}</div>
            )}

            {/* {inputData.kuraFileInfo?.key && !isDownLoading && (
              <div className={classes.groupTalkTextItemTextDeleteButton}
                onClick={(() => {
                  showFileUploadModalHandler();
                })}
              >
                <span>
                  {marks.downloadMark} get-origial-file-store
                </span>
              </div>
            )} */}

            {isDownLoading && (
              <Loader />
            )}

            <GroupTextItemReplys 
              inputData={inputData}
              lsNameDataList={lsNameDataList}
              // replyTexts={replyTexts}
              setShowTextSettings={setShowTextSettings}
            />

            {inputData.fromUserId === userId && (
              <div className={classes.groupTalkTextItemTextDeleteButton}
                onClick={() => { 
                  showDeleteTextModalHandler();
                }}
              >
                {marks.trashMark} {t('groupTalk.text62', 'Delete post')}
              </div>
            )}
          </SmallModal>
      </div>
    );
  }
   


  return (
    <Fragment>
      <div>
        {textSettingsBody}
      </div>
      {showFileUploadModal && (
        <div>
          <TransBackdrop onClick={showFileUploadModalHandler} />
          <SmallModal style={classes.groupTalkTextItemConfirmModal}>
            <div>
              <div className={classes.groupTalkTextItemConfirmModalClose}>
                <span
                  onClick={showFileUploadModalHandler}
                >
                  X
                </span>
              </div>
              <FilesUploadAction 
                filePaths={inputData.filePaths}
                uploadApp={`groupTalk-${inputData.groupRoomId}`}
                kuraFileInfo={inputData.kuraFileInfo}
                groupRoomId={inputData.groupRoomId}
              />
            </div>
          </SmallModal>
        </div>
      )}
      {showDeleteTextModal &&
        <GroupTalkTextModal
          modalName='delete-text'
          // modalTitle='Is it no problem to delete this post?'
          modalTitle={`${t('groupTalk.text63', 'Is it no problem to delete this post?')}`}
          showModalHandler={showDeleteTextModalHandler}
          onCancel={showDeleteTextModalHandler}
          onConfirm={groupTextDeleteHandler}
          groupRoomId={inputData.groupRoomId}
          groupTalkTextId={inputData._id}
          fromUserId={inputData.fromUserId}
          // groupTextDeleteHandler={groupTextDeleteHandler}
          inputData={inputData}
          isLoading={isLoading}
          // modalContent={deleteMemberModalContent}
        />
      }
      {showReplyModal && (
        <div>
          <TransBackdrop onClick={() => {
              showReplyModalHandler(false);
            }} 
          />
          <SmallModal style={classes.groupTalkTextItemConfirmModal}>
            <div>
              <div className={classes.groupTalkTextItemConfirmModalClose}>
                <span
                  onClick={() => {
                    showReplyModalHandler(false);
                  }}
                >
                  X
                </span>
              </div>
              <GroupTalkTextReplyAction
                inputData={inputData}
                groupTextPostHandler={groupTextPostHandler}
                isTextPosting={isTextPosting}
                showReplyModalHandler={showReplyModalHandler}
              />
            </div>
          </SmallModal>
        </div>
      )}
    </Fragment>
  );
}

export default GroupTalkTextItemSettings;